/** Disease model filter options for GDA evidence (26.3), ordered by frequency. */
export const DISEASE_MODEL_GDA = [
  'Patient studies',
  'Mouse',
  'Biospecimens',
  'Primary cells',
  'Population studies',
  'Human Studies',
  'Cancer cell lines',
  'Cell Line Models',
  'In Vivo',
  'In Vitro',
  'Rat',
  'Models',
  'Loss-of-function',
  'Animal Models',
  'Epidemiological studies',
  'Transgenic',
  'Humanized models',
  'Data-driven models',
  'Non-cancer cell lines',
  'Clinical trials',
  'Generic cell lines',
  'Dog',
  'Rodents',
  'Zebrafish',
  'Genetic Models',
  'Stem cell models',
  'Drosophila',
  'Computational Models',
  'Other non-rodent mammals',
  '3D cultures',
  'Ex Vivo Systems',
  'iPSC models',
  'Organoids',
  'Embryonic stem cell models',
  'Mechanistic models',
  'Surgical models',
  'Gain-of-function',
  'C. elegans',
  'Pig',
  'Other rodents',
  'Rabbit',
  'Other vertebrates',
  'Physiological assays',
  'Yeast',
  'Organotypic cultures',
  'Macaque',
  'Non-human primates',
  'Co-culture systems',
  'Xenopus',
  'Invertebrates',
  'Tissue slices',
  'Other NHP',
  'Microphysiological systems',
  'Electronic Health Records',
  'Marmoset',
  'Biobanks',
  'Behavioural tests',
  'Perfused organs',
  'Human-derived Systems',
  'Behavioural and functional assays',
  'Non-mammalian vertebrates',
  'Non-rodent mammals',
  'Advanced In Vitro',
  'Other model organisms',
] as const;

/** VDA and GDA use the same backend allowable values. */
export const DISEASE_MODEL_VDA = DISEASE_MODEL_GDA;

export const SEX_OPTIONS = ['Female', 'Male', 'Transgender woman', 'Transgender man'] as const;
